var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20481_407067",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20481_407067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 24.0003V21.0003H22V24.0003H2ZM6 16.4138H7.2365L15.5365 8.12905L14.9078 7.4908L14.2848 6.8773L6 15.1773V16.4138ZM4.5 17.9138V14.5388L15.7098 3.34455C15.8546 3.19971 16.019 3.09013 16.203 3.0158C16.3868 2.94146 16.5782 2.9043 16.777 2.9043C16.976 2.9043 17.1687 2.94146 17.355 3.0158C17.5413 3.09013 17.7121 3.20488 17.8673 3.36005L19.0693 4.5773C19.2244 4.72213 19.3366 4.88805 19.4058 5.07505C19.4749 5.26188 19.5095 5.45505 19.5095 5.65455C19.5095 5.84155 19.4744 6.02746 19.4042 6.2123C19.3341 6.3973 19.2224 6.56638 19.0693 6.71955L7.875 17.9138H4.5ZM15.5365 8.12905L14.9078 7.4908L14.2848 6.8773L15.5365 8.12905Z",
    fill: "#FA8F21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePencil);
export default __webpack_public_path__ + "static/media/orangePencil.26a8239b97caa090483f3f5572c62cd6.svg";
export { ForwardRef as ReactComponent };